import { createContext, useState } from 'react';

export const DrawerContext = createContext();

//contexto para manejar el estado del drawer y la transicion de abrir/cerrar 
export const DrawerProvider = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isDrawerTransitioning, setIsDrawerTransitioning] = useState(false);
  const [drawerLoading, setDrawerLoading] = useState(false);
  
  const toggleDrawerWithTransition = (open) => {
    if (open !== drawerOpen) {
      if (drawerOpen && !open){
        setIsDrawerTransitioning(true);
      }

      setDrawerOpen(open);
      
      if(isDrawerTransitioning || (drawerOpen && !open)){
        setTimeout(() => {
          setIsDrawerTransitioning(false);
        }, 310);
      }
    }
  };
  
  return (
    <DrawerContext.Provider value={{ 
      drawerOpen, 
      setDrawerOpen,
      isDrawerTransitioning,
      toggleDrawerWithTransition,
      drawerLoading,
      setDrawerLoading
    }}>
      {children}
    </DrawerContext.Provider>
  );
};